import React from 'react';
import { useSelector } from 'react-redux';

import BrandListItem from './BrandListItem';

interface Props {
  onSelect: (id: string) => void;
  selectedBrand: string | null;
  handleClickRemoveConnectedAccount: (id: string) => void;
}

const BrandList: React.FC<Props> = ({ onSelect, selectedBrand, handleClickRemoveConnectedAccount }) => {
  const { multiBrands } = useSelector((state: any) => state.user);
  return (
    <div className="p-6 pb-0 brand-list-container">
      {multiBrands.map((brand: any, index: number) => {
        const totalTeammembers = brand?.teamMembers?.length;
        const isSelected = selectedBrand === brand.connectedBrandTeamMemberId;
        return (
          <BrandListItem
            key={index}
            totalTeammembers={totalTeammembers}
            isSelected={isSelected}
            brand={brand}
            onSelect={onSelect}
            handleClickRemoveConnectedAccount={handleClickRemoveConnectedAccount}
          />
        );
      })}
    </div>
  );
};

export default BrandList;
